import { useCallback } from "react";

import useLazyRestQuery from "@/remoteState/useLazyRestQuery";

const useLazyKeyTermsGet = () => {
  const createResource = useCallback(({ contentId, levelId }) => {
    const skip = !contentId || !levelId;
    if (skip) return undefined;

    const resource = `/api/v3/content/${contentId}/key-terms/`;

    const params = { level_id: levelId };
    const queryString = new URLSearchParams(params).toString();

    return `${resource}?${queryString}`;
  }, []);

  return useLazyRestQuery(createResource);
};

export default useLazyKeyTermsGet;
